var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 200,
    viewBox: "0 0 130 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3693 199.99C28.0183 187.611 28.9578 174.658 30.983 162.152C31.4737 159.009 32.0896 155.885 32.6115 152.751C33.0813 149.617 33.4571 146.415 34.6681 143.417C35.7955 140.41 37.3405 137.557 38.9273 134.744C40.4827 132.046 42.3931 129.078 41.4223 125.924C41.0673 123.858 40.5976 121.316 40.3366 119.453L40.2426 119.24V119.22L40.2322 119.201C40.2322 119.152 38.3531 111.022 38.374 110.983C37.7372 107.461 36.3488 100.369 35.6494 96.847H36.1191L34.9708 102.668C34.6994 104.027 34.2401 106.442 33.9269 107.772C33.8434 107.995 33.8121 108.325 33.6764 108.538L32.8621 109.906L32.883 109.848C30.7951 118.066 27.6842 126.08 23.5816 133.618C19.9696 140.216 14.5308 149.336 10.6265 155.885C10.7204 155.584 10.1776 157.747 10.1985 157.709C10.3968 159.581 10.5743 162.113 10.9605 164.16C11.8061 168.468 13.0901 172.718 13.2676 177.113L13.5704 180.382C13.7896 181.488 13.1841 182.614 12.944 183.652L12.8814 183.448C14.917 185.088 14.917 187.97 13.7165 190.046L13.6226 190.24L13.4033 190.153C9.39465 188.639 6.31507 185.369 3.65306 182.498C0.886663 180.344 0.656999 176.628 0.176794 173.678L0.0202049 173.086L0.00976562 173.038V172.989C0.218551 171.767 0.813588 169.109 1.02237 167.954C1.23116 166.964 1.96191 160.6 2.16025 159.445C5.26071 149.792 7.53647 139.963 10.2507 130.213C12.2863 122.926 14.1758 115.465 17.934 108.732C21.5668 101.979 22.1514 94.2274 23.4772 86.8635C24.4794 80.6347 25.1475 74.3768 26.087 68.1481C27.1309 62.3947 31.5467 59.2997 37.7163 59.2997C39.7311 59.0959 43.7607 58.6205 45.7754 58.4459C47.0073 58.281 48.6358 57.8638 49.544 57.4466C52.728 55.1569 53.4692 51.179 54.1164 47.6959C54.0955 47.8512 54.1582 44.5427 54.1477 44.5621C54.2521 44.8823 50.8907 36.8586 50.9011 36.8877C49.21 35.7332 47.9468 32.4927 47.2161 30.3097C46.4436 27.9521 45.6293 25.1384 47.4249 22.9943C48.0094 21.9367 47.8633 20.6172 47.9572 19.3851C48.5001 15.6497 48.7089 11.895 49.9929 8.29552C53.1664 0.941298 62.9271 -1.66858 70.5269 1.04802C73.0114 1.863 75.663 3.26011 76.5817 5.70505C77.9597 7.98505 79.1184 10.5755 79.8492 13.166C80.6321 15.7662 80.7469 18.4731 81.6969 21.0344L82.3128 22.9749C82.4485 23.6346 82.8243 24.207 82.8348 24.9832C82.5425 26.3609 82.1562 27.6222 81.7491 28.932C80.8513 31.5031 80.0371 34.1905 78.0432 36.2765C77.2185 39.2357 75.0575 43.0583 75.329 46.6093C75.402 50.1797 76.9992 53.6919 79.6091 56.3017C81.6238 57.4951 84.7347 57.8056 87.3341 58.019C89.7143 58.3295 93.0966 58.6205 95.4767 58.8825C101.657 59.843 104.026 65.2568 104.361 70.496C105.624 80.3922 106.918 90.8026 109.215 100.534C110.207 105.589 113.401 109.828 115.144 114.631C117.013 119.414 118.297 124.362 119.675 129.262C122.42 139.1 124.717 149.015 127.828 158.747C128.12 160.833 128.82 166.848 129.3 168.905L129.968 172.262V172.31C129.509 173.998 129.456 175.861 128.924 177.637C128.538 179.179 127.546 180.8 126.325 181.77C123.548 184.758 120.583 187.863 116.554 189.425L116.334 189.512L116.24 189.318C115.019 187.222 115.082 184.389 117.076 182.721L117.013 182.924C116.762 181.886 116.167 180.761 116.376 179.655L116.668 176.385C117.023 169.807 119.539 163.53 119.748 156.923V156.991L119.278 155.079L119.31 155.147C113.109 144.465 105.603 133.085 101.135 121.714C99.5167 117.813 98.5876 113.7 97.6585 109.634C97.4497 109.285 96.6042 108.441 96.2805 107.733L96.6772 107.801L96.6355 107.84L96.4163 108.043C93.7647 103.367 93.0131 97.7396 90.7373 92.9467L90.6642 92.7721L91.1236 92.7139C90.5494 96.9246 90.2258 101.164 89.9126 105.404C89.422 111.759 89.2445 118.153 88.0962 124.44C87.9187 126.526 88.3049 128.641 89.2758 130.533C91.2175 134.414 92.6477 138.479 94.2971 142.437L95.9256 148.297L95.8212 148.162C95.9047 148.21 96.03 148.307 96.0613 148.462C96.0822 148.637 96.0196 148.753 95.9465 148.841L95.9882 148.647L96.9487 152.12C98.1805 160.056 99.9238 167.944 100.675 175.958C101.448 183.943 101.448 192.054 100.467 199.99C102.523 183.943 99.6524 167.944 96.5415 152.198C96.5728 152.314 95.5289 148.734 95.5289 148.763L95.4976 148.666L95.5707 148.569V148.559C95.5916 148.53 95.5916 148.511 95.5916 148.54C95.5916 148.559 95.602 148.559 95.5707 148.54L95.4872 148.492L95.4663 148.404C95.4663 148.404 93.8169 142.457 93.8482 142.573C92.1884 138.605 90.7791 134.559 88.8478 130.717C87.8456 128.767 87.4385 126.555 87.6264 124.401C89.4011 113.894 89.161 103.202 90.6642 92.646L90.7791 91.7825C91.468 93.296 92.1466 94.8678 92.6477 96.4686C93.9004 100.029 94.9026 104.221 96.6877 107.539L96.3223 107.51L96.3641 107.471L96.6146 107.238C96.9278 108.053 97.6063 108.645 98.1283 109.46C99.1096 113.544 99.9969 117.648 101.615 121.549C106.073 132.881 113.61 144.3 119.769 154.943V154.973L120.228 156.874V156.913C120.03 163.54 117.514 169.817 117.149 176.414L116.856 179.694C116.648 180.78 117.263 181.809 117.504 182.944C115.541 184.516 115.52 187.096 116.668 189.114L116.355 189.008C118.297 188.241 120.04 187.106 121.596 185.787C123.172 184.457 124.56 182.944 125.97 181.45C128.632 179.306 128.778 175.89 129.31 172.854V172.834L129.467 172.242V172.339L128.788 168.973C128.308 166.896 127.63 161.027 127.316 158.795C124.237 149.248 121.898 139.119 119.174 129.369C117.128 122.024 115.228 114.583 111.397 107.849C107.858 100.932 107.231 93.0923 105.906 85.6313L104.809 78.0928C103.859 73.232 104.392 67.7503 101.751 63.3649C100.362 61.2401 98.003 59.7266 95.3514 59.3191C93.0757 59.0765 89.5785 58.7467 87.2402 58.4556C84.5259 58.2228 81.6447 57.9899 79.2437 56.6219C78.5547 55.9622 77.9179 55.2054 77.4064 54.4098C74.6504 50.5387 74.1076 45.5518 75.6839 41.1761C76.3416 39.42 77.0619 37.7803 77.6047 35.9854C80.3711 32.9681 81.3628 28.6991 82.4172 24.9347C82.4277 24.3429 82.0623 23.6831 81.9266 23.0331L81.3315 21.0927C80.4129 18.541 80.3085 15.7953 79.5569 13.1951C78.847 10.5949 77.7613 8.09178 76.3729 5.73416C75.9658 4.5505 75.0575 3.57058 73.9927 2.82351C66.2155 -2.27011 53.8554 -0.339386 50.1391 8.32463C49.283 10.6725 49.0012 13.1854 48.688 15.6497C48.5523 16.8819 48.3331 18.1432 48.2287 19.3657C48.1347 20.5881 48.3331 21.8979 47.6858 23.1107C46.9238 24.1488 46.5271 25.3131 46.6732 26.555C47.3622 30.0671 48.5418 34.1323 51.3187 36.6937L54.5862 44.4457L54.6071 44.4845V44.5233L54.5653 47.7056C54.5653 47.7056 54.5653 47.7347 54.5653 47.7444C53.9076 51.3439 53.1038 55.3703 49.8259 57.7571C47.6545 58.8631 44.1991 58.9989 41.7772 59.2609L37.7372 59.7072C29.271 59.8139 26.515 64.6844 25.9722 71.9125C25.4085 76.9188 24.6464 81.9057 23.9157 86.8926C22.5794 94.2856 21.9844 102.096 18.3202 108.907C14.5725 115.621 12.7039 123.014 10.6787 130.3C7.97491 140.031 5.67828 149.889 2.58826 159.542C2.34816 161.395 1.58609 167.721 1.12677 169.681L0.448214 173.048V172.951C1.1894 176.143 1.03281 179.868 3.92448 182.148C6.69089 185.107 9.57212 188.202 13.539 189.726L13.2259 189.832C14.3742 187.795 14.3429 185.243 12.3907 183.662C12.6308 182.517 13.2572 181.488 13.038 180.412L12.7352 177.142C12.5369 174.959 12.3281 172.786 11.8896 170.651C10.7726 166.392 9.91662 162.036 9.66607 157.641C9.66607 157.641 10.1463 155.72 10.1358 155.7C10.1358 155.681 10.1567 155.652 10.1672 155.632C18.7795 141.089 28.5716 126.099 32.3714 109.731V109.702L32.3923 109.673L33.2066 108.305L33.217 108.286C33.4676 107.587 33.6972 106.248 33.8747 105.492C34.2401 103.629 35.2214 98.6807 35.5972 96.75L35.8373 95.5469C36.7455 100.078 37.9773 106.452 38.802 110.973C38.7081 110.731 40.6915 119.152 40.6498 119.104C40.5976 118.958 40.7333 119.288 40.7333 119.278C40.7333 119.288 40.7542 119.317 40.7542 119.337C41.0673 121.5 41.464 123.664 41.819 125.837C42.2679 127.312 42.0904 129.136 41.4954 130.61C39.5015 135.006 36.568 138.964 34.9395 143.514C33.7181 146.493 33.3319 149.646 32.8412 152.78C32.3088 155.914 31.672 159.038 31.1605 162.172C29.0518 174.658 28.0705 187.601 31.3275 199.981L31.3693 199.99Z",
    fill: "url(#paint0_linear_953_3368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.162 173.649C123.162 173.649 123.11 173.63 123.078 173.63C123.037 173.63 122.995 173.639 122.974 173.678C122.964 173.688 122.964 173.698 122.953 173.707C122.348 174.474 121.847 174.901 121.262 174.707C121.21 174.687 121.168 174.697 121.137 174.726C121.095 174.745 121.085 174.794 121.085 174.833C121.178 175.822 120.803 177.666 120.437 179.461L120.375 179.752C120.364 179.82 120.406 179.878 120.479 179.897H120.5C120.563 179.897 120.615 179.858 120.625 179.8C121.366 176.977 122.149 175.143 123.162 173.853C123.172 173.853 123.172 173.833 123.183 173.814C123.225 173.765 123.214 173.688 123.162 173.649ZM121.126 177.278C121.272 176.375 121.377 175.57 121.356 174.978C121.669 175.036 121.972 174.939 122.233 174.774C121.836 175.473 121.471 176.288 121.126 177.278Z",
    fill: "url(#paint1_linear_953_3368)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84803 174.328C6.84803 174.328 6.85847 174.357 6.86891 174.367C7.88152 175.658 8.66446 177.491 9.40565 180.315C9.41609 180.373 9.46828 180.412 9.53092 180.412H9.5518C9.62487 180.392 9.66663 180.334 9.65619 180.266L9.59355 179.975C9.22818 178.18 8.85237 176.337 8.94632 175.347C8.94632 175.308 8.93588 175.26 8.89413 175.24C8.86281 175.211 8.82105 175.202 8.76885 175.221C8.18426 175.415 7.68317 174.988 7.0777 174.222C7.0777 174.212 7.0777 174.202 7.05682 174.193C7.03594 174.154 6.99418 174.144 6.95242 174.144C6.92111 174.144 6.88979 174.144 6.86891 174.163C6.81671 174.202 6.80627 174.28 6.84803 174.328ZM7.798 175.289C8.05898 175.454 8.36172 175.551 8.6749 175.493C8.65402 176.084 8.75841 176.89 8.90456 177.792C8.56007 176.802 8.19469 175.987 7.798 175.289Z",
    fill: "url(#paint2_linear_953_3368)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0039 199.991C58.2923 193.616 60.3592 186.699 61.0378 179.665C61.2257 179.141 61.6641 178.646 62.2383 178.394C63.9399 177.763 65.6728 178.801 67.0717 179.548C67.3118 183.08 67.9173 186.611 68.8046 190.065C69.6711 193.48 70.8924 196.828 72.521 200C70.6941 197.138 69.504 193.461 68.5019 190.133C67.5415 186.718 66.8629 183.245 66.5393 179.713L66.6646 179.917C65.4118 179.257 63.8981 178.355 62.468 178.859C62.0608 179.044 61.7477 179.383 61.5598 179.8L61.5806 179.723C60.7037 186.718 58.5324 193.868 55.0039 200V199.991Z",
    fill: "url(#paint3_linear_953_3368)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7316 67.3138L63.3767 67.013C63.5124 66.8772 63.5332 66.6929 63.5228 66.5764C63.5124 66.3242 63.3767 66.0622 63.1783 65.8973C62.8129 65.5868 62.2701 65.4704 61.7481 65.354C57.4994 64.4614 53.355 63.2486 49.3672 61.7351L49.5447 61.3179C53.5011 62.8217 57.6246 64.0248 61.8003 64.898C62.4058 65.0338 63.0322 65.1793 63.4915 65.5674C63.7838 65.8197 63.9821 66.1883 63.9926 66.557C64.003 66.8578 63.9091 67.1198 63.7212 67.3235L63.7316 67.3138Z",
    fill: "url(#paint4_linear_953_3368)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6442 67.6532C66.3832 67.0128 66.8008 66.3046 67.3437 65.9359C67.8656 65.5866 68.5337 65.4896 69.1288 65.4023L78.0961 64.0537C79.2444 63.8693 80.3823 63.6947 81.2905 63.1514L81.5515 63.5298C80.5597 64.1216 79.3697 64.3059 78.2214 64.4903L69.2436 65.8486C68.6381 65.9359 68.0535 66.0232 67.6255 66.3143C67.2393 66.5762 66.9156 67.0807 67.0931 67.5076L66.6442 67.6629V67.6532Z",
    fill: "url(#paint5_linear_953_3368)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1565 127.763C88.6349 127.487 88.7989 126.875 88.5229 126.397C88.2469 125.918 87.6353 125.754 87.157 126.03L88.1565 127.763ZM43.2115 128.993C43.6997 129.251 44.3048 129.064 44.563 128.576C44.8212 128.088 44.6347 127.483 44.1465 127.225L43.2115 128.993ZM48.4395 129.146C47.9229 128.95 47.3458 129.211 47.1505 129.728C46.9553 130.244 47.2158 130.821 47.7324 131.016L48.4395 129.146ZM52.4304 132.512C52.9646 132.652 53.5112 132.332 53.6512 131.798C53.7913 131.264 53.4717 130.717 52.9375 130.577L52.4304 132.512ZM57.5616 131.543C57.016 131.457 56.5044 131.83 56.4188 132.376C56.3333 132.921 56.7062 133.433 57.2519 133.519L57.5616 131.543ZM62.1514 134.034C62.7029 134.064 63.174 133.641 63.2037 133.089C63.2335 132.538 62.8105 132.067 62.259 132.037L62.1514 134.034ZM66.9805 132.046C66.4289 132.074 66.0042 132.544 66.032 133.096C66.0598 133.647 66.5295 134.072 67.081 134.044L66.9805 132.046ZM71.9875 133.535C72.5331 133.448 72.9053 132.936 72.8191 132.391C72.7328 131.845 72.2207 131.473 71.6752 131.559L71.9875 133.535ZM76.2891 130.573C75.756 130.717 75.4408 131.266 75.5851 131.8C75.7294 132.333 76.2785 132.648 76.8116 132.504L76.2891 130.573ZM81.4937 130.964C82.0085 130.764 82.2636 130.185 82.0636 129.67C81.8635 129.155 81.284 128.9 80.7693 129.1L81.4937 130.964ZM85.078 127.162C84.5865 127.414 84.3924 128.017 84.6443 128.509C84.8963 129 85.4989 129.194 85.9904 128.942L85.078 127.162ZM41.0562 127.736C41.6927 128.148 42.4137 128.571 43.2115 128.993L44.1465 127.225C43.3956 126.827 42.7257 126.434 42.1431 126.057L41.0562 127.736ZM47.7324 131.016C49.1738 131.561 50.7462 132.07 52.4304 132.512L52.9375 130.577C51.3224 130.154 49.8167 129.666 48.4395 129.146L47.7324 131.016ZM57.2519 133.519C58.8217 133.765 60.4587 133.943 62.1514 134.034L62.259 132.037C60.6369 131.95 59.0673 131.779 57.5616 131.543L57.2519 133.519ZM67.081 134.044C68.6834 133.963 70.3217 133.798 71.9875 133.535L71.6752 131.559C70.0818 131.811 68.5142 131.969 66.9805 132.046L67.081 134.044ZM76.8116 132.504C78.3589 132.085 79.9217 131.575 81.4937 130.964L80.7693 129.1C79.2643 129.685 77.769 130.173 76.2891 130.573L76.8116 132.504ZM85.9904 128.942C86.7121 128.572 87.4343 128.179 88.1565 127.763L87.157 126.03C86.4634 126.431 85.7702 126.808 85.078 127.162L85.9904 128.942Z",
    fill: "#EB6262"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0639 94.6933C91.5611 94.4529 91.7693 93.8549 91.529 93.3577C91.2886 92.8605 90.6906 92.6523 90.1934 92.8927L91.0639 94.6933ZM37.3584 95.7507C37.8611 95.9794 38.4541 95.7572 38.6827 95.2545C38.9114 94.7518 38.6893 94.1589 38.1865 93.9302L37.3584 95.7507ZM42.5052 95.631C41.9826 95.4525 41.4142 95.7316 41.2358 96.2543C41.0573 96.7769 41.3364 97.3453 41.859 97.5237L42.5052 95.631ZM46.4727 98.8951C47.0078 99.032 47.5525 98.7092 47.6894 98.1742C47.8263 97.6391 47.5036 97.0944 46.9685 96.9575L46.4727 98.8951ZM51.5277 97.949C50.9841 97.851 50.4641 98.2122 50.3661 98.7557C50.2682 99.2993 50.6294 99.8193 51.1729 99.9173L51.5277 97.949ZM55.9344 100.603C56.4835 100.663 56.9768 100.266 57.0363 99.7169C57.0958 99.1678 56.699 98.6745 56.1499 98.615L55.9344 100.603ZM60.8017 98.954C60.2498 98.9334 59.7856 99.364 59.765 99.9159C59.7443 100.468 60.175 100.932 60.7269 100.953L60.8017 98.954ZM65.5379 100.961C66.0899 100.942 66.522 100.479 66.503 99.9267C66.484 99.3748 66.0211 98.9427 65.4692 98.9617L65.5379 100.961ZM70.1184 98.6314C69.5693 98.6908 69.1724 99.1841 69.2318 99.7331C69.2912 100.282 69.7844 100.679 70.3335 100.62L70.1184 98.6314ZM75.0953 99.9239C75.6383 99.8235 75.9972 99.3019 75.8969 98.7588C75.7965 98.2157 75.2749 97.8568 74.7318 97.9572L75.0953 99.9239ZM79.2809 96.9363C78.747 97.0777 78.4289 97.6252 78.5703 98.159C78.7117 98.6929 79.2592 99.011 79.793 98.8696L79.2809 96.9363ZM84.3969 97.4588C84.9183 97.2769 85.1935 96.7066 85.0115 96.1852C84.8296 95.6637 84.2593 95.3886 83.7379 95.5705L84.3969 97.4588ZM88.0758 93.8674C87.5698 94.0887 87.3391 94.6783 87.5604 95.1843C87.7817 95.6903 88.3714 95.9211 88.8774 95.6997L88.0758 93.8674ZM35.1804 94.672C35.8329 95.0259 36.561 95.3879 37.3584 95.7507L38.1865 93.9302C37.4274 93.5849 36.7416 93.2435 36.134 92.9139L35.1804 94.672ZM41.859 97.5237C43.2801 98.0089 44.8231 98.4729 46.4727 98.8951L46.9685 96.9575C45.3695 96.5483 43.8767 96.0992 42.5052 95.631L41.859 97.5237ZM51.1729 99.9173C52.6977 100.192 54.2879 100.425 55.9344 100.603L56.1499 98.615C54.5514 98.4417 53.0077 98.2158 51.5277 97.949L51.1729 99.9173ZM60.7269 100.953C62.2937 101.011 63.8995 101.017 65.5379 100.961L65.4692 98.9617C63.8801 99.0164 62.3222 99.011 60.8017 98.954L60.7269 100.953ZM70.3335 100.62C71.8998 100.45 73.4888 100.221 75.0953 99.9239L74.7318 97.9572C73.1759 98.2447 71.6364 98.4672 70.1184 98.6314L70.3335 100.62ZM79.793 98.8696C81.3182 98.4656 82.8542 97.9972 84.3969 97.4588L83.7379 95.5705C82.2445 96.0917 80.7575 96.5451 79.2809 96.9363L79.793 98.8696ZM88.8774 95.6997C89.6058 95.381 90.3348 95.0458 91.0639 94.6933L90.1934 92.8927C89.4872 93.2341 88.7812 93.5588 88.0758 93.8674L88.8774 95.6997Z",
    fill: "#EB6262"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_953_3368",
    x1: 64.6282,
    y1: 183.793,
    x2: 64.9436,
    y2: 0.931506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856476
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898013,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_953_3368",
    x1: 121.794,
    y1: 187.251,
    x2: 121.794,
    y2: 158.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_953_3368",
    x1: 8.24689,
    y1: 187.766,
    x2: 8.24689,
    y2: 158.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_953_3368",
    x1: 63.7624,
    y1: 198.962,
    x2: 63.7624,
    y2: 159.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_953_3368",
    x1: 49.3672,
    y1: 64.3158,
    x2: 64.003,
    y2: 64.3158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_953_3368",
    x1: 66.5711,
    y1: 65.4023,
    x2: 81.5619,
    y2: 65.4023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFCw);
export default __webpack_public_path__ + "static/media/F_cw.77de197c18d21fe373c3807e907c1ff6.svg";
export { ForwardRef as ReactComponent };